import { createRoot } from 'react-dom/client';
import React from 'react';
import { getJackpotsData, } from './utils.js';
import Jackpots from './Jackpots.mjs';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return false;
    }

    return this.props.children;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const jackpotsTab = document.querySelector('a[href="#jackpot"]');
  if (jackpotsTab) {
    jackpotsTab.classList.add('d-none');
  }

  const appDiv = document.getElementById('jackpotsApp');
  const validPropertyCodes = ["WCA", "WCB", "WCM", "WCW"];
  const currentPropertyCode = WindCreekData.propertyCode;

  // TODO: Potentially filter out jackpot data by date, though this doesn't seem too important.

  const root = createRoot(appDiv);

  getJackpotsData('ALL')
    .then(response => {
      if (response.data.getJackpotsByProperty) {
        return {
          total: response.data.getJackpotsByProperty.total,
          jackpots: response.data.getJackpotsByProperty.jackpots.slice(0, 10),
        };
      } else {
        console.error('Error: Failed to parse response for `ALL` jackpot data.');
      }
    })
    .then((all) => {
      if (validPropertyCodes.includes(currentPropertyCode)) {
        const propertyDataQuery = getJackpotsData(currentPropertyCode);

        return propertyDataQuery.then((pData) => {
          return {
            all: all,
            property: {
              total: pData.data.getJackpotsByProperty.total,
              jackpots: pData.data.getJackpotsByProperty.jackpots.slice(0, 10),
            },
          };
        }).catch((err) => {
          console.error('Error:', err);
        });
      }

      return {
        all: all,
        property: false,
      };
    })
    .then((data) => {
      if (jackpotsTab) {
        jackpotsTab.classList.remove('d-none');
      }

      root.render(
        <ErrorBoundary>
          <Jackpots
            propertyName={ validPropertyCodes.includes(currentPropertyCode) ? WindCreekData.propertyName : false }
            allTotal={data.all.total}
            allJackpots={data.all.jackpots}
            propertyTotal={data.property.total}
            propertyJackpots={data.property.jackpots}
          />
        </ErrorBoundary>
      );
    })
    .catch(error => {
      console.error('Error:', error);
    })
  ;
});
